module.exports = __webpack_public_path__ + "img/image35.a4cde849.png";